<template>
    <v-card class="stat-card">
        <v-card-text>
            <div class="card-heading">
                <div class="card-title">Новых абонементов за</div>
                <v-select
                        v-model="period"
                        :items="periods"
                        return-object
                        item-text="name"
                        @change="onPeriodChange"
                        outlined
                        dense
                        hide-details
                />
                <router-link :to="{name: 'cards.list', query: {period: period.value, page: 1}}" class="card-value">
                    {{total}}
                </router-link>
            </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="mt-auto">
            <stat-cards-chart
                    v-if="chartData"
                    :chart-data="chartData"
                    :height="158"
                    :period="period.value"
                    class="card-chart"
            />
        </v-card-text>
    </v-card>
</template>

<script>
    import statisticApi from '../api/statistic.api';

    export default {
        name   : "StatCards",
        data() {
            return {
                chartData: null,
                total    : null,

                period : {
                    name : 'Сегодня',
                    value: 'today'
                },
                periods: [
                    {
                        name : 'Все время',
                        value: 'all'
                    },
                    {
                        name : 'Последние 30 дней',
                        value: 'last_30_days'
                    },
                    {
                        name : 'Последние 7 дней',
                        value: 'last_7_days'
                    },
                    {
                        name : 'Вчера',
                        value: 'yesterday'
                    },
                    {
                        name : 'Сегодня',
                        value: 'today'
                    },
                ],
            }
        },
        created() {
            this.fetchStat();
        },
        methods: {
            onPeriodChange() {
                this.chartData = null;
                this.fetchStat();
            },
            fetchStat() {
                this.$store.commit('setLoading', true);

                statisticApi.cards({period: this.period ? this.period.value : null}).then(({data}) => {
                    this.total = data.total;
                    this.fillChartData(data.data);
                }).catch(() => {
                    this.$toast.error('Что-то пошло не так. Пожалуйста, повторите попытку позже');
                }).finally(() => {
                    this.$store.commit('setLoading', false);
                });
            },
            fillChartData(stats) {
                const data = [];

                stats.forEach((stat) => {
                    data.push({
                        x: stat.date,
                        y: stat.count,
                    });
                });

                this.chartData = {
                    datasets: [
                        {
                            label          : 'Абонементов ',
                            type           : 'bar',
                            data           : data,
                            fill           : false,
                            backgroundColor: '#19b7e8',
                            borderColor    : '#19b7e8',
                        }
                    ],
                };
            }
        }
    }
</script>

<style scoped>

</style>
